module.exports = __webpack_public_path__ + "static/media/facebookcontorno.62a9901e.svg";